import { useState } from 'react'
import { X, Zap, Package } from 'lucide-react'
import { T } from '../theme'

const API = import.meta.env.VITE_API_URL || 'https://backend-pued.onrender.com/api'

function authHeaders() {
  const token = localStorage.getItem('insightball_token')
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
}

const OPTIONS = [
  {
    type: 'unit',
    label: '1 analyse IA',
    price: '15€',
    description: 'Une analyse de match complète.',
    Icon: Zap,
  },
  {
    type: 'pack',
    label: 'Pack 5 analyses',
    price: '55€',
    sub: '11€ / analyse',
    description: '-27% sur le prix unitaire',
    best: true,
    Icon: Package,
  },
]

export default function BuyAnalysesModal({ onClose, hasCredits = false }) {
  const [loading, setLoading] = useState(null)
  const [error, setError]     = useState(null)

  const handleBuy = async (type) => {
    setLoading(type)
    setError(null)
    try {
      const res = await fetch(`${API}/subscription/buy-analyses`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({
          type,
          success_url: window.location.origin + '/dashboard/matches',
          cancel_url:  window.location.href,
        }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data?.detail || 'Erreur lors de la création du paiement.')
        return
      }
      if (data.url) window.location.href = data.url
    } catch {
      setError('Erreur réseau. Réessaie.')
    } finally {
      setLoading(null)
    }
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(10,9,8,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#1a1916',
          border: '1px solid rgba(79,142,247,0.25)',
          padding: '32px 28px',
          maxWidth: 460,
          width: '100%',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 14, right: 14,
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'rgba(245,242,235,0.4)', padding: 4,
          }}
        >
          <X size={16} />
        </button>

        <p style={{ fontFamily: T.mono, fontSize: 8, letterSpacing: '.18em', textTransform: 'uppercase', color: T.gold, marginBottom: 6 }}>
          {hasCredits ? 'Analyses IA · Acheter des crédits' : 'Analyses IA · Quota épuisé'}
        </p>
        <h2 style={{ fontFamily: T.display, fontSize: 22, textTransform: 'uppercase', color: '#f5f2eb', margin: '0 0 8px' }}>
          Obtenir des analyses
        </h2>
        <p style={{ fontFamily: T.mono, fontSize: 11, color: 'rgba(245,242,235,0.5)', margin: '0 0 28px', lineHeight: 1.5 }}>
          {hasCredits
            ? 'Achète une réserve d\'analyses utilisable à tout moment.'
            : 'Tes analyses mensuelles sont épuisées. Achète une réserve utilisable à tout moment.'}
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
          {OPTIONS.map(({ type, label, price, sub, description, best, Icon }) => (
            <button
              key={type}
              onClick={() => handleBuy(type)}
              disabled={!!loading}
              style={{
                background: best ? 'rgba(79,142,247,0.08)' : 'rgba(245,242,235,0.03)',
                border: `1px solid ${best ? 'rgba(79,142,247,0.35)' : 'rgba(255,255,255,0.1)'}`,
                padding: '20px 16px',
                cursor: loading ? 'wait' : 'pointer',
                textAlign: 'left',
                opacity: loading && loading !== type ? 0.5 : 1,
                transition: 'all .15s',
                position: 'relative',
              }}
              onMouseEnter={e => { if (!loading) e.currentTarget.style.borderColor = 'rgba(79,142,247,0.55)' }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = best ? 'rgba(79,142,247,0.35)' : 'rgba(255,255,255,0.1)' }}
            >
              {best && (
                <span style={{
                  position: 'absolute', top: -8, right: 10,
                  background: T.gold, color: '#0f0e0c',
                  fontFamily: T.mono, fontSize: 7, letterSpacing: '.12em', textTransform: 'uppercase',
                  padding: '2px 8px',
                }}>
                  Meilleure offre
                </span>
              )}
              <Icon size={18} color={T.gold} style={{ marginBottom: 10 }} />
              <div style={{ fontFamily: T.mono, fontSize: 10, color: '#f5f2eb', fontWeight: 700, letterSpacing: '.04em', marginBottom: 4 }}>
                {label}
              </div>
              <div style={{ fontFamily: T.display, fontSize: 26, color: best ? T.gold : '#f5f2eb', lineHeight: 1, marginBottom: 4 }}>
                {price}
              </div>
              {sub && (
                <div style={{ fontFamily: T.mono, fontSize: 8, color: 'rgba(245,242,235,0.45)', letterSpacing: '.06em', marginBottom: 8 }}>
                  {sub}
                </div>
              )}
              <div style={{ fontFamily: T.mono, fontSize: 9, color: 'rgba(245,242,235,0.4)', lineHeight: 1.4 }}>
                {description}
              </div>
              {loading === type && (
                <div style={{ marginTop: 10, fontFamily: T.mono, fontSize: 8, color: T.gold, letterSpacing: '.08em' }}>
                  Redirection...
                </div>
              )}
            </button>
          ))}
        </div>

        {error && (
          <p style={{ fontFamily: T.mono, fontSize: 10, color: '#ef4444', marginTop: 4, letterSpacing: '.04em' }}>
            {error}
          </p>
        )}

        <p style={{ fontFamily: T.mono, fontSize: 8, color: 'rgba(245,242,235,0.25)', marginTop: 16, letterSpacing: '.04em' }}>
          Paiement sécurisé via Stripe · Analyses ajoutées instantanément
        </p>
      </div>
    </div>
  )
}
